export default __webpack_public_path__ + "static/FirstsafetyFeatureOne-7cbaf565a76e645fe78948a25aaae5b3.webp";